// extracted by mini-css-extract-plugin
module.exports = {"bigBtn":"Button_bigBtn__2JwRJ","default":"Button_default__18Fup Button_bigBtn__2JwRJ","intro":"Button_intro__1kxON Button_bigBtn__2JwRJ"};